import { render, staticRenderFns } from "./technology.vue?vue&type=template&id=346a703a&scoped=true&"
import script from "./technology.vue?vue&type=script&lang=js&"
export * from "./technology.vue?vue&type=script&lang=js&"
import style0 from "./technology.vue?vue&type=style&index=0&id=346a703a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a703a",
  null
  
)

export default component.exports